'use strict';
angular.module('bringgApp.directives').directive('cxGreenFleet', function () {
	return {
		templateUrl: 'scripts/directives/green-fleet-directive.html',
		replace: true,
		restrict: 'E'
	};
});
